/** 選択肢データ */
export interface FormOption {
  cd: number | string;
  text: string;
  area_cd?: string;
};

/** 選択肢データ */
let formOptions: Record<string, FormOption[]>;

/**
 * スライドフォームの選択肢を取得
 */
export function getFormOptions() {
  if(!formOptions) {
    /** data要素から選択肢のデータセットを取得 */
    const formOptionsDataset = document.getElementById('form_options')?.dataset;

    if(formOptionsDataset) {
      // データセットをJSONパースして変数にセット
      formOptions = Object.fromEntries(
        Object.entries(formOptionsDataset).map(([key, value]) => [key, JSON.parse(value)])
      );
    }
  }

  return formOptions;
}

/**
 * 雇用形態の選択肢を取得
 */
export function getEmploymentTypes(): FormOption[] {
  return getFormOptions().employmentTypes;
}

/**
 * 転職時期の選択肢を取得
 */
export function getWishfulTimes(): FormOption[] {
  return getFormOptions().wishfulTimes;
}

/**
 * 都道府県の選択肢を取得
 */
export function getPrefectures(): FormOption[] {
  return getFormOptions().prefectures;
}

/**
 * 業種の選択肢を取得
 */
export function getPositionTypes(): FormOption[] {
  return getFormOptions().positionTypes;
}

/**
 * 業種の選択肢を取得
 */
export function getBusinessCategories(): FormOption[] {
  return getFormOptions().businessCategories;
}

/**
 * 生まれ年の選択肢を取得
 */
export function getBirthYears(): FormOption[] {
  return getFormOptions().birthYears;
}

/**
 * 地方の選択肢を取得
 */
export function getAreas(): FormOption[] {
  return getFormOptions().areas;
}

/**
 * 性別の選択肢を取得
 */
export function getGenderTypes(): FormOption[] {
  return getFormOptions().genderTypes;
}

/**
 * 地方コードから都道府県の選択肢を取得
 * 
 * @param areaCd 
 * @returns FormOption[]
 */
export function getPrefecturesByAreaCd(areaCd: string): FormOption[] {
  return getPrefectures().filter(prefecture => prefecture.area_cd === areaCd);
}

/**
 * 希望勤務日数の選択肢を取得
 */
export function getWorkFrequencies(): FormOption[] {
  return getFormOptions().workFrequencies;
}

/**
 * 希望退勤時間の選択肢を取得
 */
export function getLeaveTimes(): FormOption[] {
  return getFormOptions().leaveTimes;
}
